import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const LockIconNew = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                d="M15.8333 9.15002H4.16667C3.24619 9.15002 2.5 9.91114 2.5 10.85V16.8C2.5 17.7389 3.24619 18.5 4.16667 18.5H15.8333C16.7538 18.5 17.5 17.7389 17.5 16.8V10.85C17.5 9.91114 16.7538 9.15002 15.8333 9.15002Z"
                fill="none"
                stroke={props.htmlColor ?? '#A7A9AC'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.83325 9.15V5.75C5.83325 4.62283 6.27224 3.54183 7.05364 2.7448C7.83504 1.94777 8.89485 1.5 9.99992 1.5C11.105 1.5 12.1648 1.94777 12.9462 2.7448C13.7276 3.54183 14.1666 4.62283 14.1666 5.75V9.15"
                fill="none"
                stroke={props.htmlColor ?? '#A7A9AC'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
